const KEY = 'neon.settings.v1';

const DEFAULTS = {
  musicVolume: 0.6,
  effectsVolume: 0.8,
  vibration: true,
  graphicsQuality: 'medium', // low | medium | high
  touchControls: 'auto', // auto | on | off
  language: 'es', // es | it | en
};

let cache = null;
const listeners = new Set();

export function getSettings() {
  if (cache) return cache;
  try {
    const raw = localStorage.getItem(KEY);
    cache = raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch {
    cache = { ...DEFAULTS };
  }
  return cache;
}

export function setSettings(patch) {
  const prev = getSettings();
  cache = { ...prev, ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch {
    // ignore
  }
  listeners.forEach((cb) => cb(cache, prev));
  return cache;
}

export function resetSettings() {
  cache = { ...DEFAULTS };
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch {
    // ignore
  }
  listeners.forEach((cb) => cb(cache, cache));
  return cache;
}

export function onSettingsChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function shouldShowTouchControls() {
  const s = getSettings();
  if (s.touchControls === 'on') return true;
  if (s.touchControls === 'off') return false;
  // auto: detect touch device
  return typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
}
